import { AllocationViewFiltersModel } from '../../../allocation-view/models';
import { AllocationViewFilterProfileModel } from '../../models';

export class AllocationViewFilterProfileItemCreate {
  public static readonly type = '[AllocationViewFilterProfileItem] Create profile';

  constructor(public payload: { name: string; filter: AllocationViewFiltersModel }) {}
}

export class AllocationViewFilterProfileItemSet {
  public static readonly type = '[AllocationViewFilterProfileItem] Set profile';

  constructor(public payload: AllocationViewFilterProfileModel) {}
}

export class AllocationViewFilterProfileItemGetSelected {
  public static readonly type = '[AllocationViewFilterProfileItem] Get selected profile';
}

export class AllocationViewFilterProfileItemUpdate {
  public static readonly type = '[AllocationViewFilterProfileItem] Update profile';

  constructor(public payload: AllocationViewFilterProfileModel) {}
}

export class AllocationViewFilterProfileItemDelete {
  public static readonly type = '[AllocationViewFilterProfileItem] Delete profile';

  constructor(public payload: number, public callback?: () => void) {}
}

export class AllocationViewFilterProfileItemInitialState {
  public static readonly type = '[AllocationViewFilterProfileItem] Set Initial State';
}
